
import { MaterialInput } from 'app/components/material';
import * as utils from 'app/utils'
import * as _ from 'lodash'
import * as moment from 'moment'
import * as React from 'react'
import { Modal } from 'react-bootstrap'
import { default as InfiniteCalendar } from 'react-infinite-calendar'

interface IYearMonthModalProps {
  defaultDate?: moment.Moment
  onChange: (w: moment.Moment) => void
  placeholder: string
  prompt: string
  title?: string
}

interface IYearMonthModalState {
  show: boolean
}

class YearMonthModal extends React.Component<IYearMonthModalProps, IYearMonthModalState> {
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    const title = this.props.title || 'Choose A Date'
    const defaultDate = (this.props.defaultDate || utils.todaysDate()).add(1, 'day').local().toDate()
    const minDate = new Date(2018, 0, 1)
    const maxDate = new Date(2060, 0, 1)

    return (
      <div>
        <MaterialInput placeholder="When will you begin payments?"
          onClick={this.handleShow}
          value={this.props.prompt} />

        <Modal dialogClassName={'YearMonthModal'} show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <InfiniteCalendar width={400} height={300} selected={defaultDate}
              display={'years'}
              min={minDate} minDate={minDate}
              max={maxDate} maxDate={maxDate}
              onSelect={(e) => {
                const when = moment.utc(e)
                this.props.onChange(when)
                this.handleClose()
              }}
              displayOptions={{
                //layout: 'landscape',
                showHeader: false
              }}>
            </InfiniteCalendar>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export {
  YearMonthModal
}



// WEBPACK FOOTER //
// ./src/app/components/YearMonthModal/index.tsx